import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed } from 'vue'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import type { ClueManage, ClueManageParams } from '@/typings/api/marketingManage'
import { cluePushRecordList } from '@/api/marketing/marketingManage'
import InvalidModel from '@/views/yuntuSales/marketLeads/components/invalidModel.vue'
import CosRangePicker from '@/components/CosRangePicker'

const __default__ = { name: 'DcCosLbuDeliveryRecord' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const invalidModelRef = ref()
const tableRef = ref()
const searchFrom = ref<ClueManageParams>({})
const selectedRows = ref<any[]>([])
const fetch = (params: object, callBack: (res: any) => void) => {
  cluePushRecordList(params).then((res) => {
    callBack(res)
  })
}
const onSelectChange = (selectedRowKeys: string[], rows: ClueManage[]) => {
  selectedRows.value = rows
}
const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const search = () => {
  tableRef.value.search()
}
// 置为无效
const handleInvalid = (row?: ClueManage) => {
  let result = []
  if (row && row.clueId) {
    result.push(row)
  } else {
    result = selectedRows.value
  }
  invalidModelRef.value.toggle(result)
}
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    path: '/lbu/deliveryRecord/view',
    query: ['clueId', 'contact_contactRefId'],
    width: 200
  },
  {
    title: 'ID',
    dataIndex: 'clueId',
    width: 200
  },
  {
    title: '投放人',
    dataIndex: 'operatorName'
  },
  {
    title: '投放时间',
    dataIndex: 'createTime',
    width: 190
  },
  {
    title: '手机号',
    dataIndex: ['contact', 'mobile'],
    width: 140
  },
  {
    title: '投放结果',
    dataIndex: 'pushResult',
    dicData: dataConfig.cluePushResultEnum
  },
  {
    title: '失败原因',
    dataIndex: 'resultDesc',
    width: 200
  },
  {
    title: '线索类型',
    dataIndex: 'clueType',
    dicData: dataConfig.clueType
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 120
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            rowKey: "cluePushRecordId",
            "row-selection": { onChange: onSelectChange },
            columns: columns.value,
            serial: "",
            onFetch: fetch,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosLbuDeliveryRecord",
            search: searchFrom.value,
            "onUpdate:search": _cache[8] || (_cache[8] = ($event: any) => ((searchFrom).value = $event))
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "pushResult",
                    label: "投放结果"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: searchFrom.value.pushResult,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.value.pushResult) = $event)),
                        optionType: "button",
                        onChange: search,
                        options: [
                  { label: '全部', value: undefined },
                  { label: '成功', value: 1 },
                  { label: '失败', value: 0 }
                ]
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "线索类型" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: searchFrom.value.clueType,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchFrom.value.clueType) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(dataConfig).clueType
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: "客户名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerName,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.value.customerName) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.clueId,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.value.clueId) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "投放时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CosRangePicker), {
                        startTime: searchFrom.value.createStartTime,
                        "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.value.createStartTime) = $event)),
                        endTime: searchFrom.value.createEndTime,
                        "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.value.createEndTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "投放人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: searchFrom.value.operator,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom.value.operator) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "手机号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.mobile,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchFrom.value.mobile) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, { onClick: handleInvalid }, {
                default: _withCtx(() => [
                  _createTextVNode(" 置为无效 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_lead_invalid_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'action')
                ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "link",
                    onClick: ($event: any) => (handleInvalid(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 置为无效 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_vShow, record.clueStatus === 0 && record.clueType !== 3],
                    [_directive_permission, 'lbu_lead_invalid_btn']
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["row-selection", "columns", "search"]),
          _createVNode(InvalidModel, {
            ref_key: "invalidModelRef",
            ref: invalidModelRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})